module.exports = __webpack_public_path__ + "static/img/success.9e4b865e.svg";